module.exports = __webpack_public_path__ + "static/img/组 2849.6f2fded.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/auditing/images/组 2849.png
// module id = QauU
// module chunks = 0